var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2684FF",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M28 10.667H4m6.667-4V4m10.666 2.667V4M6.667 5.333h-.134A2.533 2.533 0 0 0 4 7.867V24a2.667 2.667 0 0 0 2.667 2.667h18.666A2.667 2.667 0 0 0 28 24V7.867c0-1.4-1.134-2.534-2.533-2.534h-.134m-10.666 0h2.666"
})));
export default SvgCalendarBlue;